import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from 'src/utils/analytics'

/**
 * RouteTracker Component
 *
 * This component tracks page views whenever the route changes.
 * It should be placed inside a Router context (e.g., in a layout component).
 *
 * Features:
 * - Automatically tracks route changes
 * - Includes query parameters in tracking
 * - Tracks initial page load
 */
export const RouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change
    // Combine pathname and search to include query parameters
    const fullPath = location.pathname + location.search
    trackPageView(fullPath)
  }, [location])

  // This component doesn't render anything
  return null
}
